import { MarketingV2DetailItemApiModel } from '@cxb/content-stb-api';
import { MarketingV2DetailPageApiModel } from '@cxb/content-stb-api/model/marketingV2DetailPageApiModel';
import { Entity } from '@nx-data/nx-data';

export class MarketingDetailPageItemEntity extends Entity implements MarketingV2DetailPageApiModel {
  public pageItems: Array<MarketingV2DetailItemApiModel>;
}
